/**
 * PAPPO — KYC Service (/api/kyc)
 * Envio de identidade (RG + selfie) e consulta de status pelo próprio usuário.
 */

import { apiGet, apiUpload } from './api';
import type { KycStatusResponse } from '../types/kyc';

/** Status da verificação de identidade do usuário atual. */
export async function getKycStatus() {
  return apiGet<KycStatusResponse>('/kyc/status');
}

/**
 * Envia RG + selfie (multipart). Documentos NÃO são comprimidos — o original
 * é enviado para preservar a nitidez exigida na revisão humana.
 */
export async function enviarKyc(rg: File, selfie: File) {
  const formData = new FormData();
  formData.append('rg', rg);
  formData.append('selfie', selfie);
  return apiUpload<{ id: number; verification_status: string }>(
    '/kyc/enviar',
    formData
  );
}
